"use client";
import { motion } from "framer-motion";
import { ArrowUpRight, Github } from "lucide-react";
import Link from "next/link";

export default function ProjectCard({ project, index }) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1, ease: "easeOut" }}
            viewport={{ once: true }}
            className="group relative flex flex-col overflow-hidden rounded-2xl bg-white/5 backdrop-blur-md border border-white/10 hover:border-[#ff5500]/30 shadow-xl shadow-black/40 hover:shadow-[#ff5500]/5 hover:-translate-y-2 transition-all duration-300 h-full"
        >
            <div className="relative aspect-video overflow-hidden bg-black/50">
                <img
                    src={project.thumbnail || project.images?.[0] || "/image.jpg"}
                    alt={project.name}
                    className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/0 transition duration-500" />
            </div>

            <div className="flex flex-col flex-grow p-6">
                <div className="flex justify-between items-start mb-4">
                    <Link
                        href={project.slug ? `/projects/${project.slug}` : project.link || "#"}
                        className="group/link"
                    >
                        <h3 className="text-xl font-bold text-white group-hover/link:text-[#ff5500] transition-colors flex items-center gap-2">
                            {project.name}
                            <ArrowUpRight size={18} className="translate-y-0.5 -translate-x-0.5 opacity-0 group-hover/link:opacity-100 group-hover/link:translate-x-0 group-hover/link:translate-y-0 transition-all duration-300" />
                        </h3>
                    </Link>
                    {project.github && (
                        <Link href={project.github} className="text-muted-foreground hover:text-white transition-colors duration-300">
                            <Github size={20} />
                        </Link>
                    )}
                </div>

                <p className="text-muted-foreground text-sm leading-relaxed mb-6 line-clamp-3">
                    {project.summary}
                </p>

                <div className="mt-auto flex flex-wrap gap-2">
                    {project.techStack?.slice(0, 4).map((tech) => (
                        <span key={tech} className="text-xs font-mono px-2 py-1 rounded bg-white/5 text-muted-foreground border border-white/5 hover:border-[#ff5500]/25 hover:text-white transition-colors duration-300">
                            {tech}
                        </span>
                    ))}
                    {project.techStack?.length > 4 && (
                        <span className="text-xs font-mono px-2 py-1 text-muted-foreground">
                            +{project.techStack.length - 4}
                        </span>
                    )}
                </div>
            </div>
        </motion.div>
    );
}
